// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1___b58aeccca8a5a45dd1e","cls2":"AccountMenuButton-cls2___b1ec5438486a6b41e89 AccountMenuButton-cls1___b58aeccca8a5a45dd1e"};